module.exports = __webpack_public_path__ + "img/DPD_login_logo.7b8f418c.png";